import type { CSSProperties } from "react";
import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useNotificationContext } from "../NotificationContext";

export interface NoNotificationsProps {
  className?: string;
  style?: CSSProperties;
}

export const NoNotifications = ({ className, style }: NoNotificationsProps) => {
  const { activeTab } = useNotificationContext();

  return (
    // h-[calc(100%-92px)] is the height of the list minus the height of the header, tabs and margin.
    <div
      className={classNames(
        "flex h-[calc(100%-92px)] w-full flex-col items-center justify-center space-y-2 overflow-y-auto px-6 py-2 text-center [scrollbar-gutter:stable]",
        className,
      )}
      style={style}
    >
      <Typography.TitleMd>
        {t(`header_v3.no_notifications.${activeTab || "inbox"}`)}
      </Typography.TitleMd>
      <Typography.BodyMd>
        {t(`header_v3.no_notifications_description.${activeTab || "inbox"}`)}
      </Typography.BodyMd>
    </div>
  );
};
